
// Function to check visibility of an element
function isElementVisible(el) {
    return el && el.offsetWidth > 0 && el.offsetHeight > 0;
}

// Function to trigger gpoElementChanged event
function triggerGpoElementChanged() {
    let event = new CustomEvent('gpoElementChanged', { bubbles: true, cancelable: true });
    document.dispatchEvent(event);
}

// Select the target node - in this case, we assume there's a specific container where .gpo-app will be
const targetNode = document.querySelector('body'); // Use body as a fallback

// Options for the observer (which mutations to observe)
const config = { attributes: true, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = function(mutationsList, observer) {
    for (let mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length) {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1) {
                    const gpoApp = node.matches('.gpo-app') ? node : node.querySelector('.gpo-app');
                    if (gpoApp && isElementVisible(gpoApp)) {
                        triggerGpoElementChanged();
                        observer.disconnect();
                    }
                }
            });
        }
    }
};

// Create an instance of MutationObserver with the callback
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);

let hasOrganizedSwatches = false;

document.addEventListener('gpoElementChanged', function() {
  updateSummaryTable();
    if (hasOrganizedSwatches) return;

    function createCategoryContainer(categoryName) {
        let container = document.createElement('div');
        let subheading = document.createElement('h6');
        subheading.textContent = categoryName;
        subheading.className = 'category-heading';
        container.appendChild(subheading);
        return container;
    }

    function organizeSwatches() {
    let swatchGroups = document.querySelectorAll('.gpo-element.gpo-form__group');

    swatchGroups.forEach(group => {
        let linenSwatches = [];
        let cottonSwatches = [];
        let velvetSwatches = [];
        let silkSwatches = [];
        let otherSwatches = [];

        let swatches = group.querySelectorAll('.gpo-swatches.image-swatches');
        swatches.forEach(swatch => {
            let value = swatch.querySelector('input[type="radio"]').value;
            if (value.includes('- Linen')) {
                linenSwatches.push(swatch);
            } else if (value.includes('- Cotton')) {
                cottonSwatches.push(swatch);
            } else if (value.includes('- Velvet')) {
                velvetSwatches.push(swatch);
            } else if (value.includes('- Silk')) {
                silkSwatches.push(swatch);
            } else {
                otherSwatches.push(swatch);
            }
        });

        if (linenSwatches.length > 0) {
            let linenContainer = createCategoryContainer('Linen');
            linenSwatches.forEach(swatch => linenContainer.appendChild(swatch));
            group.appendChild(linenContainer);
        }

        if (cottonSwatches.length > 0) {
            let cottonContainer = createCategoryContainer('Cotton');
            cottonSwatches.forEach(swatch => cottonContainer.appendChild(swatch));
            group.appendChild(cottonContainer);
        }

        if (velvetSwatches.length > 0) {
            let velvetContainer = createCategoryContainer('Velvet');
            velvetSwatches.forEach(swatch => velvetContainer.appendChild(swatch));
            group.appendChild(velvetContainer);
        }

        if (silkSwatches.length > 0) {
            let silkContainer = createCategoryContainer('Silk');
            silkSwatches.forEach(swatch => silkContainer.appendChild(swatch));
            group.appendChild(silkContainer);
        }

        otherSwatches.forEach(swatch => group.appendChild(swatch));
    });

    hasOrganizedSwatches = true;
}

    organizeSwatches();
});
let tabsInitialized = false;
let accordionInitialized = false;

// Mobile detection function
function isMobile() {
    return window.innerWidth <= 768;
}

// Function to get current item count for discount calculations
function getItemCount() {
    let itemCount = 0;
    
    // Get all selected items and count them
    const selectedValues = document.querySelectorAll('.gpo-selected-values.has-value');
    selectedValues.forEach(selectedValue => {
        let labelContent = selectedValue.previousElementSibling.querySelector('.label-content').textContent.trim();
        if (labelContent === "Add Another Pillowcase set?" || labelContent === "Size") {
            return;
        }

        let addOnPriceElement = selectedValue.previousElementSibling.querySelector('.addOn');
        if (addOnPriceElement) {
            let price = parseFloat(addOnPriceElement.textContent.match(/[\d\.]+/)[0]);
            if (price > 0) {
                itemCount++;
            }
        }
    });
    
    return itemCount;
}

// Function to initialize size slider on mobile
function initializeSizeSlider() {
    if (!isMobile()) return;
    
    // Size slider initialization
    
    // The actual container is .gpo-ov-wrapper.horizontal
    let sizeContainers = document.querySelectorAll('.gpo-ov-wrapper.horizontal');
    
    // If not found, try more specific selectors
    if (sizeContainers.length === 0) {
        sizeContainers = document.querySelectorAll('[class*="-size"] .gpo-ov-wrapper');
    }
    
    // Found size containers
    
    sizeContainers.forEach((container, index) => {
        // Processing size container
        
        // Add a class to identify styled containers
        container.classList.add('size-slider-mobile');
        
        // Auto-scroll to selected item when page loads or selection changes
        const scrollToSelected = () => {
            const selectedButton = container.querySelector('.gpo-swatches.buttons input:checked');
            if (selectedButton) {
                const buttonWrapper = selectedButton.closest('.gpo-swatches.buttons');
                if (buttonWrapper) {
                    // Scroll the selected button into view (centered)
                    buttonWrapper.scrollIntoView({ 
                        behavior: 'smooth', 
                        inline: 'center',
                        block: 'nearest'
                    });
                }
            }
        };
        
        // Scroll to selected on load
        setTimeout(scrollToSelected, 100);
        
        // Listen for changes to auto-scroll to newly selected
        container.addEventListener('change', function(e) {
            if (e.target.type === 'radio') {
                setTimeout(scrollToSelected, 50);
            }
        });
    });
    
    // Try again after a delay if nothing found
    if (sizeContainers.length === 0) {
        // No size containers found, retrying
        setTimeout(initializeSizeSlider, 500);
    }
}

// Function to update accordion height when content changes
function updateAccordionHeight() {
    if (!isMobile()) return;
    
    // Find the currently open accordion
    const activeHeader = document.querySelector('.accordion-header.active');
    if (!activeHeader) return;
    
    const accordionItem = activeHeader.closest('.accordion-item');
    if (!accordionItem) return;
    
    const contentArea = accordionItem.querySelector('.accordion-content');
    if (!contentArea || contentArea.style.display !== 'block') return;
    
    // Recalculate and update the height
    const newHeight = contentArea.scrollHeight;
    contentArea.style.maxHeight = newHeight + 'px';
    // Updated accordion height
}

// Function to update confirm button state based on selections
function updateConfirmButtonState() {
    if (!isMobile()) return;
    
    document.querySelectorAll('.accordion-item').forEach(item => {
        const content = item.querySelector('.accordion-content');
        const confirmButton = item.querySelector('.accordion-confirm-button');
        
        if (!content || !confirmButton) return;
        
        // Check if there are any selections with prices in this accordion
        let hasSelection = false;
        const selectedValues = content.querySelectorAll('.gpo-selected-values.has-value');
        
        selectedValues.forEach(selectedValue => {
            const labelElement = selectedValue.previousElementSibling;
            if (labelElement) {
                const labelContent = labelElement.querySelector('.label-content')?.textContent.trim();
                
                // Skip Size and pillowcase set selections
                if (labelContent === "Add Another Pillowcase set?" || labelContent === "Size") {
                    return;
                }
                
                const addOnPriceElement = labelElement.querySelector('.addOn');
                if (addOnPriceElement) {
                    const priceMatch = addOnPriceElement.textContent.match(/[\d\.]+/);
                    if (priceMatch) {
                        const price = parseFloat(priceMatch[0]);
                        if (price > 0) {
                            hasSelection = true;
                        }
                    }
                }
            }
        });
        
        // Update button text and class
        if (hasSelection) {
            confirmButton.textContent = 'Next Step';
            confirmButton.classList.remove('no-selection');
        } else {
            confirmButton.textContent = 'Skip Step';
            confirmButton.classList.add('no-selection');
        }
    });
}

// Function to update selected text in accordion headers
function updateAccordionSelectedText() {
    if (!isMobile()) return;
    
    document.querySelectorAll('.accordion-item').forEach(item => {
        const header = item.querySelector('.accordion-header');
        const content = item.querySelector('.accordion-content');
        const selectedTextSpan = header.querySelector('.accordion-selected-text');
        
        if (!content || !selectedTextSpan) return;
        
        // Use same logic as getItemCount - check for .gpo-selected-values.has-value
        let hasSwatchSelection = false;
        
        // Find all selected values within this specific accordion content
        const selectedValues = content.querySelectorAll('.gpo-selected-values.has-value');
        selectedValues.forEach(selectedValue => {
            // Get the label content from the previous sibling
            const labelElement = selectedValue.previousElementSibling;
            if (labelElement) {
                const labelContent = labelElement.querySelector('.label-content')?.textContent.trim();
                
                // Skip Size and pillowcase set selections
                if (labelContent === "Add Another Pillowcase set?" || labelContent === "Size") {
                    return;
                }
                
                // Check if it has a price (add-on)
                const addOnPriceElement = labelElement.querySelector('.addOn');
                if (addOnPriceElement) {
                    const priceMatch = addOnPriceElement.textContent.match(/[\d\.]+/);
                    if (priceMatch) {
                        const price = parseFloat(priceMatch[0]);
                        if (price > 0) {
                            hasSwatchSelection = true;
                        }
                    }
                }
            }
        });
        
        // Show "selected" only if there are swatch selections with prices
        if (hasSwatchSelection) {
            selectedTextSpan.textContent = 'selected';
            selectedTextSpan.style.display = 'inline';
        } else {
            selectedTextSpan.textContent = '';
            selectedTextSpan.style.display = 'none';
        }
    });
}

// Modify the tabs initialization to check for actual visible swatches
document.addEventListener('gpoElementChanged', function() {
    if (tabsInitialized && !isMobile()) return;
    if (accordionInitialized && isMobile()) return;

    const categories = {
    'fitted-sheet': 'Fitted Sheet',
    'quilt-cover': 'Quilt Cover',
    'flat-sheet': 'Flat Sheet',
    'euro': 'Euro Pillowcase Sets',
    'pillowcases': 'Pillowcase Sets',
    'feature-pillowcase': 'Feature Pillowcase',
    'valance': 'Valance',
};

    const tabControls = document.getElementById('tab-controls');
    const tabContent = document.getElementById('tab-content');

    if (!tabControls || !tabContent) {
        console.error("Tab containers not found.");
        return;
    }

    // Initialize based on screen size
    if (isMobile()) {
        initializeAccordion(categories, tabControls, tabContent);
    } else {
        initializeTabs(categories, tabControls, tabContent);
    }
});

// Function to initialize desktop tabs
function initializeTabs(categories, tabControls, tabContent) {
    function resetTabs() {
        document.querySelectorAll('#tab-content > div').forEach(div => div.style.display = 'none');
        document.querySelectorAll('#tab-controls a').forEach(link => link.classList.remove('active'));
    }

    tabControls.innerHTML = '';
    tabControls.classList.remove('accordion-container');
    tabControls.classList.add('tab-list');
    tabContent.style.display = ''; // Ensure tab content is visible on desktop
    let firstTab = null;

    Object.keys(categories).forEach((category, index) => {
        let contentArea = document.getElementById(category);
        if (!contentArea) {
            contentArea = document.createElement('div');
            contentArea.id = category;
            contentArea.style.display = 'none';
            tabContent.appendChild(contentArea);
        }

        document.querySelectorAll(`.gpo-element.gpo-form__group[class*="${category}"]`).forEach(group => {
            contentArea.appendChild(group);
        });

        // Check for available swatches using the same logic as markUnavailableSwatches
        const swatches = contentArea.querySelectorAll('input[type="radio"][gpo-data-variant-id]');
        let hasAvailableSwatches = false;

        swatches.forEach(input => {
            const variantId = input.getAttribute('gpo-data-variant-id');
            const variantData = document.querySelector(`.variant-data[data-variant-id="${variantId}"]`);
            
            if (variantData && variantData.querySelector('.variant-available')) {
                hasAvailableSwatches = true;
            }
        });

        if (hasAvailableSwatches) {
            const tabLink = document.createElement('a');
            tabLink.href = `#${category}`;
            tabLink.textContent = categories[category];
            tabLink.dataset.target = category;

            const listItem = document.createElement('li');
            listItem.appendChild(tabLink);
            tabControls.appendChild(listItem);

            tabLink.addEventListener('click', function(e) {
                e.preventDefault();
                resetTabs();
                document.getElementById(this.dataset.target).style.display = 'block';
                this.classList.add('active');
            });

            if (!firstTab) {
                firstTab = tabLink;
            }
        }
    });

    if (firstTab) {
        firstTab.classList.add('active');
        document.getElementById(firstTab.dataset.target).style.display = 'block';
    }

    tabsInitialized = true;
}

// Function to initialize mobile accordions
function initializeAccordion(categories, tabControls, tabContent) {
    tabControls.innerHTML = '';
    tabControls.classList.remove('tab-list');
    tabControls.classList.add('accordion-container');

    let accordionNumber = 1; // Counter for accordion numbering

    Object.keys(categories).forEach((category, index) => {
        let contentArea = document.getElementById(category);
        if (!contentArea) {
            contentArea = document.createElement('div');
            contentArea.id = category;
            contentArea.className = 'accordion-content';
            contentArea.style.display = 'none';
        } else {
            contentArea.className = 'accordion-content';
        }

        document.querySelectorAll(`.gpo-element.gpo-form__group[class*="${category}"]`).forEach(group => {
            contentArea.appendChild(group);
        });
        
        // Add confirm button to each accordion section
        const confirmButton = document.createElement('button');
        confirmButton.className = 'accordion-confirm-button no-selection';
        confirmButton.type = 'button';
        confirmButton.textContent = 'Skip Step';
        confirmButton.dataset.category = category;
        contentArea.appendChild(confirmButton);

        // Check for available swatches
        const swatches = contentArea.querySelectorAll('input[type="radio"][gpo-data-variant-id]');
        let hasAvailableSwatches = false;

        swatches.forEach(input => {
            const variantId = input.getAttribute('gpo-data-variant-id');
            const variantData = document.querySelector(`.variant-data[data-variant-id="${variantId}"]`);
            
            if (variantData && variantData.querySelector('.variant-available')) {
                hasAvailableSwatches = true;
            }
        });

        if (hasAvailableSwatches) {
            // Create accordion item
            const accordionItem = document.createElement('div');
            accordionItem.className = 'accordion-item';

            // Create accordion header - MUST be type="button" to prevent form submission
            const accordionHeader = document.createElement('button');
            accordionHeader.type = 'button'; // Critical: prevent form submission
            accordionHeader.className = 'accordion-header';
            accordionHeader.innerHTML = `
                <div class="accordion-header-content">
                    <span class="accordion-title">${accordionNumber}. ${categories[category]}</span>
                    <span class="accordion-selected-text"></span>
                </div>
                <svg class="accordion-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            `;
            accordionHeader.dataset.target = category;

            // Increment counter for next accordion
            accordionNumber++;
            
            // Move content area into accordion item
            accordionItem.appendChild(accordionHeader);
            accordionItem.appendChild(contentArea);
            tabControls.appendChild(accordionItem);
            
            // Add click handler with event prevention
            accordionHeader.addEventListener('click', function(e) {
                // Accordion clicked
                e.preventDefault(); // Prevent any form submission
                e.stopPropagation(); // Stop event bubbling
                
                const isOpen = contentArea.style.display === 'block';
                
                // Close all accordions
                document.querySelectorAll('.accordion-content').forEach(content => {
                    content.style.display = 'none';
                    content.style.maxHeight = null;
                });
                document.querySelectorAll('.accordion-header').forEach(header => {
                    header.classList.remove('active');
                });
                
                // Open clicked accordion if it was closed
                if (!isOpen) {
                    // Opening accordion
                    contentArea.style.display = 'block';
                    contentArea.style.maxHeight = contentArea.scrollHeight + "px";
                    this.classList.add('active');
                    
                    // Scroll to position accordion below sticky image on mobile
                    if (isMobile()) {
                        setTimeout(() => {
                            // Try multiple selectors for the sticky image container
                            const stickyImage = document.querySelector('.grid__item.product__media-wrapper') || 
                                              document.querySelector('.product__media-wrapper') ||
                                              document.querySelector('#product-media') ||
                                              document.querySelector('.media-viewer');
                            
                            const accordionHeader = this;
                            
                            if (stickyImage && accordionHeader) {
                                // Get the actual visible height - use getBoundingClientRect for rendered size
                                const stickyRect = stickyImage.getBoundingClientRect();
                                const stickyHeight = stickyRect.height;
                                
                                // If height is still too small, try to get the media viewer inside
                                let actualHeight = stickyHeight;
                                if (stickyHeight < 50) {
                                    const mediaViewer = stickyImage.querySelector('.media-viewer') || stickyImage.querySelector('img');
                                    if (mediaViewer) {
                                        actualHeight = mediaViewer.getBoundingClientRect().height;
                                    }
                                }
                                
                                // Get accordion header position
                                const accordionRect = accordionHeader.getBoundingClientRect();
                                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                                
                                // Calculate where to scroll: accordion top minus sticky height minus some padding
                                const targetScroll = scrollTop + accordionRect.top - actualHeight - 20;
                                
                                // Scroll to calculated position
                                window.scrollTo({
                                    top: targetScroll,
                                    behavior: 'smooth'
                                });
                            }
                        }, 200); // Delay to ensure accordion is fully opened
                    }
                    
                    // Trigger updates for dynamic content
                    setTimeout(() => {
                        updateSummaryTable();
                        updateFloatingBar();
                        // Update height again after content loads
                        updateAccordionHeight();
                    }, 100);
                    
                    // Another update after a bit more time for slower content
                    setTimeout(() => {
                        updateAccordionHeight();
                    }, 300);
                } else {
                    // Closing accordion
                }
            });
            
            // Open first accordion by default
            if (index === 0) {
                contentArea.style.display = 'block';
                accordionHeader.classList.add('active');
            }
        }
    });
    
    // Clear tab content since accordions are in tab-controls
    tabContent.style.display = 'none';
    accordionInitialized = true;
    
    // Add click handlers for confirm buttons
    document.querySelectorAll('.accordion-confirm-button').forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Find the parent accordion item
            const accordionItem = this.closest('.accordion-item');
            if (accordionItem) {
                const accordionHeader = accordionItem.querySelector('.accordion-header');
                const accordionContent = accordionItem.querySelector('.accordion-content');
                
                // Close this accordion
                if (accordionContent) {
                    accordionContent.style.display = 'none';
                    accordionContent.style.maxHeight = null;
                }
                if (accordionHeader) {
                    accordionHeader.classList.remove('active');
                }
                
                // Find and open the next accordion
                const nextAccordion = accordionItem.nextElementSibling;
                if (nextAccordion && nextAccordion.classList.contains('accordion-item')) {
                    const nextHeader = nextAccordion.querySelector('.accordion-header');
                    const nextContent = nextAccordion.querySelector('.accordion-content');
                    
                    if (nextHeader && nextContent) {
                        // Open next accordion
                        nextContent.style.display = 'block';
                        nextContent.style.maxHeight = nextContent.scrollHeight + "px";
                        nextHeader.classList.add('active');
                        
                        // Scroll to next accordion on mobile
                        if (isMobile()) {
                            setTimeout(() => {
                                const stickyImage = document.querySelector('.grid__item.product__media-wrapper') || 
                                                  document.querySelector('.product__media-wrapper') ||
                                                  document.querySelector('#product-media');
                                
                                if (stickyImage && nextHeader) {
                                    const stickyRect = stickyImage.getBoundingClientRect();
                                    let actualHeight = stickyRect.height;
                                    
                                    if (actualHeight < 50) {
                                        const mediaViewer = stickyImage.querySelector('.media-viewer') || stickyImage.querySelector('img');
                                        if (mediaViewer) {
                                            actualHeight = mediaViewer.getBoundingClientRect().height;
                                        }
                                    }
                                    
                                    const accordionRect = nextHeader.getBoundingClientRect();
                                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                                    const targetScroll = scrollTop + accordionRect.top - actualHeight - 20;
                                    
                                    window.scrollTo({
                                        top: targetScroll,
                                        behavior: 'smooth'
                                    });
                                }
                            }, 200);
                        }
                        
                        // Update accordion height after content loads
                        setTimeout(() => {
                            updateAccordionHeight();
                            updateAccordionSelectedText();
                        }, 100);
                    }
                }
            }
        });
    });
    
    // Initialize size slider and update selected text after accordions are ready
    setTimeout(() => {
        initializeSizeSlider();
        updateAccordionSelectedText();
    }, 200);
}

// Add this helper function at the top level of your script
function createColorizedImage(originalSrc, callback) {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = function() {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;
        
        // Convert FAF2E9 to RGB
        const targetR = 250; // FA in hex
        const targetG = 242; // F2 in hex
        const targetB = 233; // E9 in hex
        
        for (let i = 0; i < data.length; i += 4) {
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            
            // If the pixel is white-ish (you can adjust these thresholds)
            if (r > 200 && g > 200 && b > 200) {
                data[i] = targetR;     // Red
                data[i + 1] = targetG; // Green
                data[i + 2] = targetB; // Blue
            }
        }
        
        ctx.putImageData(imageData, 0, 0);
        callback(canvas.toDataURL());
    };
    img.src = originalSrc;
}
function updateSummaryTable() {
    let summaryContainer = document.getElementById('selection-summary-container');
    if (!summaryContainer) {
        summaryContainer = document.createElement('div');
        summaryContainer.id = 'selection-summary-container';

        const tabsElement = document.getElementById('tabs');
        if (tabsElement) {
            tabsElement.appendChild(summaryContainer);
        } else {
            console.error('The tabs element was not found.');
            return;
        }
    }
    summaryContainer.innerHTML = '';

    // Check if mobile - create accordion structure
    if (isMobile()) {
        // Create accordion header
        const accordionHeader = document.createElement('button');
        accordionHeader.className = 'summary-accordion-header';
        accordionHeader.type = 'button';

        // We'll update this text after calculating totals
        accordionHeader.innerHTML = `
            <span class="summary-accordion-text">Bundle Summary</span>
            <svg class="summary-accordion-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;

        // Create accordion content wrapper
        const accordionContent = document.createElement('div');
        accordionContent.className = 'summary-accordion-content';
        accordionContent.style.display = 'none'; // Initially collapsed

        // Add title inside content
        const summaryTitle = document.createElement('div');
        summaryTitle.className = 'summary-title';
        summaryTitle.textContent = 'YOUR BUNDLE';
        accordionContent.appendChild(summaryTitle);

        // Create table inside content
        const summaryTable = document.createElement('table');
        summaryTable.id = 'selection-summary-table';
        summaryTable.className = 'selection-summary';
        accordionContent.appendChild(summaryTable);

        // Add to container
        summaryContainer.appendChild(accordionHeader);
        summaryContainer.appendChild(accordionContent);

        // Add click handler for accordion
        accordionHeader.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            const isOpen = accordionContent.style.display === 'block';

            if (isOpen) {
                accordionContent.style.display = 'none';
                accordionHeader.classList.remove('active');
            } else {
                accordionContent.style.display = 'block';
                accordionHeader.classList.add('active');
            }
        });

        // Continue with existing table population logic
        var summaryTableElement = summaryTable;
    } else {
        // Desktop - keep existing structure
        const summaryTitle = document.createElement('div');
        summaryTitle.className = 'summary-title';
        summaryTitle.textContent = 'YOUR BUNDLE';
        summaryContainer.appendChild(summaryTitle);

        const summaryTable = document.createElement('table');
        summaryTable.id = 'selection-summary-table';
        summaryTable.className = 'selection-summary';
        summaryContainer.appendChild(summaryTable);

        var summaryTableElement = summaryTable;
    }

    let originalTotal = 0;
    let discountableItemCount = 0;
    let itemDetails = {};

    const selectedValues = document.querySelectorAll('input[type="radio"][data-type="image-swatches"]:checked');
selectedValues.forEach(selectedValue => {
    // Get the tooltip title element
    let tooltipTitle = selectedValue.closest('.gpo-swatches').querySelector('.gpo-tooltip__title');
    if (!tooltipTitle) return;

    let labelContent = selectedValue.getAttribute('data-field-name');
    if (labelContent === "Add Another Pillowcase set?" || labelContent === "Size") {
        return;
    }

    let selectedText = selectedValue.value;
    if (selectedText === 'Select' || selectedText === '') {
        return;
    }

    let addOnPriceElement = tooltipTitle.querySelector('.addOn');
    let addOnPrice = addOnPriceElement ? parseFloat(addOnPriceElement.textContent.match(/[\d\.]+/)[0]) : 0;

    if (addOnPrice > 0) {
        discountableItemCount++;
        originalTotal += addOnPrice;
    }

    // Get variant data
    let variantId = selectedValue.getAttribute('gpo-data-variant-id');
    let variantDataDiv = document.querySelector(`.variant-data[data-variant-id="${variantId}"]`);

    // Build unique key
    let inputName = selectedValue.getAttribute('name').replace(/__/g, '');
    let sizeMatch = inputName.match(/(Super King|USA King|California King|Single|Double|Queen|King)/);
    let size = sizeMatch ? sizeMatch[0] : '';
    let categoryName = inputName.replace(/(Super King|USA King|California King|Single|Double|Queen|King)/g, '').trim();
    let baseName = selectedText;
    let randomNum = Math.floor(Math.random() * 10000);
    let uniqueKey = `${baseName} ${categoryName}_${randomNum}`;

    if (!itemDetails[uniqueKey]) {
        itemDetails[uniqueKey] = {
            displayName: size ? `${baseName} ${categoryName} ${size}` : `${baseName} ${categoryName}`,
            name: selectedText,
            addOnPrice: addOnPrice,
            variantImage: variantDataDiv ? variantDataDiv.querySelector('[data-variant-image]').getAttribute('data-variant-image') : ''
        };
    }
});

    // Calculate discounts
    let discountPercentage = discountableItemCount >= 4 ? 15 : discountableItemCount === 3 ? 10 : 0;
    let discountedTotal = 0;

    Object.entries(itemDetails).forEach(([uniqueKey, details]) => {
        if (details.name && details.addOnPrice > 0) {
            let row = summaryTableElement.insertRow(-1);
            let cell = row.insertCell(0);
            let originalPrice = details.addOnPrice;
            let discountedPrice = originalPrice - (originalPrice * discountPercentage / 100);
            discountedTotal += discountedPrice;

            let container = document.createElement('div');
            container.style.display = 'flex';
            container.style.alignItems = 'center';
            container.style.gap = '10px';

            let imageElement = document.createElement('img');
            imageElement.style.width = '30px';
            imageElement.style.height = '30px';
            imageElement.style.objectFit = 'cover';
            imageElement.style.flexShrink = '0';

            if (details.variantImage) {
                createColorizedImage(details.variantImage, (colorizedSrc) => {
                    imageElement.src = colorizedSrc;
                });
            }

            let priceText = `<strong>$${discountedPrice.toFixed(2)}</strong>`;
            if (discountPercentage > 0) {
                priceText += ` <s>$${originalPrice.toFixed(2)}</s> - <strong style="color: #6E683B;">${discountPercentage}% off</strong>`;
            }

            let textContent = document.createElement('div');
            textContent.innerHTML = `<span class="item-name">${details.displayName}</span> ${priceText}`;

            container.appendChild(imageElement);
            container.appendChild(textContent);
            cell.appendChild(container);
        }
    });

    let totalRow = summaryTableElement.insertRow(-1);
    let totalCell = totalRow.insertCell(0);
    totalCell.colSpan = 2;

    let totalText = `<strong><span class="money-value">$${discountedTotal.toFixed(2)}</span></strong>`;
    if (discountPercentage > 0) {
        totalText += ` <span class="custom-strike-through">$${originalTotal.toFixed(2)}</span>`;
        totalText += ` <span class="discount-badge">${discountPercentage}% off</span>`;
    }

    let itemsNeededForNextDiscount = discountableItemCount < 3 ? 3 - discountableItemCount : discountableItemCount == 3 ? 1 : 0;
    let nextDiscountLevel = discountableItemCount < 3 ? 10 : discountableItemCount == 3 ? 15 : null;

    if (itemsNeededForNextDiscount > 0 && nextDiscountLevel) {
        totalText += ` | Add ${itemsNeededForNextDiscount} more piece${itemsNeededForNextDiscount > 1 ? "s" : ""} to unlock a ${nextDiscountLevel}% discount`;
    }

    totalCell.innerHTML = `<strong>Total</strong>: ${totalText}`;

    // Update accordion header text on mobile with item count and total
    if (isMobile()) {
        const accordionHeaderText = document.querySelector('.summary-accordion-text');
        if (accordionHeaderText) {
            const itemCount = Object.keys(itemDetails).filter(key => itemDetails[key].addOnPrice > 0).length;
            if (itemCount > 0) {
                accordionHeaderText.textContent = `Bundle Summary - ${itemCount} item${itemCount !== 1 ? 's' : ''} - $${discountedTotal.toFixed(2)}`;
            } else {
                accordionHeaderText.textContent = 'Bundle Summary - No items selected';
            }
        }
    }

    // Update price divs
    let priceDivs = document.querySelectorAll('.bb_product__price');
    priceDivs.forEach(div => {
        div.innerHTML = totalText;
    });
}


function markUnavailableSwatches() {
    // Get all radio buttons with a data attribute for variant IDs
    document.querySelectorAll('input[type="radio"][gpo-data-variant-id]').forEach(input => {
        const variantId = input.getAttribute('gpo-data-variant-id');
        const variantData = document.querySelector(`.variant-data[data-variant-id="${variantId}"]`);
        const swatchElement = input.closest('.gpo-swatches');

        // If there's no variant data or the variant is not available, hide the entire swatch
        if (!variantData || !variantData.querySelector('.variant-available')) {
            if (swatchElement) {
                swatchElement.style.display = 'none';
            }
        }
    });
}
// Single function to create floating bar
function createFloatingBar() {
    if (!document.querySelector('.floating-summary-bar')) {
        const floatingBar = document.createElement('div');
        floatingBar.className = 'floating-summary-bar';
        
        floatingBar.innerHTML = `
            <div class="floating-summary-content">
                <div class="floating-summary-info">
                    <div class="price-info">
                        <span class="total-price">$0.00</span>
                        <span class="savings">Save $0.00</span>
                    </div>
                    <div class="progress-section">
                        <div class="progress-bar-container">
                            <div class="progress-segment"></div>
                            <div class="progress-segment"></div>
                            <div class="progress-segment"></div>
                            <div class="progress-segment"></div>
                        </div>
                        <div class="progress-markers">
                            <div class="marker active">
                                <span>Start</span>
                            </div>
                            <div class="marker">
                                <span>1 Item</span>
                            </div>
                            <div class="marker">
                                <span>2 Items</span>
                            </div>
                            <div class="marker">
                                <span>3 Items (10% off)</span>
                            </div>
                            <div class="marker">
                                <span>4+ Items (15% off)</span>
                            </div>
                        </div>
                    </div>
                </div>
                <button type="button" class="floating-add-to-cart">Add to cart</button>
            </div>
        `;
        
        floatingBar.querySelector('.floating-add-to-cart').addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const mainAddToCartButton = document.querySelector('.gpo-clone-atc-button');
            if (mainAddToCartButton) {
                mainAddToCartButton.click();
            }
        });
        
        document.body.appendChild(floatingBar);
    }
}

// Updated updateFloatingBar function with more precise progress calculation
function updateFloatingBar() {
    const floatingBar = document.querySelector('.floating-summary-bar');
    if (!floatingBar) return;

    let itemCount = getItemCount();  // Use the new function
    let originalTotal = 0;
    let discountedTotal = 0;

    // Get all selected items and calculate totals
    const selectedValues = document.querySelectorAll('.gpo-selected-values.has-value');
    selectedValues.forEach(selectedValue => {
        let labelContent = selectedValue.previousElementSibling.querySelector('.label-content').textContent.trim();
        if (labelContent === "Add Another Pillowcase set?" || labelContent === "Size") {
            return;
        }

        let addOnPriceElement = selectedValue.previousElementSibling.querySelector('.addOn');
        if (addOnPriceElement) {
            let price = parseFloat(addOnPriceElement.textContent.match(/[\d\.]+/)[0]);
            if (price > 0) {
                originalTotal += price;
            }
        }
    });

    // Calculate discount
    let discountPercentage = itemCount >= 4 ? 15 : itemCount >= 3 ? 10 : 0;
    discountedTotal = originalTotal * (1 - discountPercentage / 100);
    let savings = originalTotal - discountedTotal;

    // Update price and savings display
    floatingBar.querySelector('.total-price').textContent = `Total: $${discountedTotal.toFixed(2)}`;
    floatingBar.querySelector('.savings').textContent = savings > 0 ? 
        `Save $${savings.toFixed(2)}` : '';

    // Update progress segments background color
    const progressSegments = floatingBar.querySelectorAll('.progress-segment');
    progressSegments.forEach((segment, index) => {
        if (index < itemCount) {
            segment.style.backgroundColor = '#e58fb8'; // Active color
        } else {
            segment.style.backgroundColor = '#faf2e9'; // Inactive color
        }
    });

    // Update markers text color
    const markers = floatingBar.querySelectorAll('.marker');
markers.forEach((marker, index) => {
    marker.classList.remove('active');
    if (index <= itemCount) {
        marker.classList.add('active');
    }
});
}

const productTitle = document.querySelector('.product-title.h5');
if (productTitle) {
    const bundleButton = document.createElement('span');
    bundleButton.className = 'bundle-button';
    bundleButton.textContent = 'bundle + save';
    productTitle.appendChild(bundleButton);
}

// Function to create description accordion on mobile
function createDescriptionAccordion() {
    if (!isMobile()) return;

    // Find the description element
    const descriptionElement = document.querySelector('[data-element-id="html-2"]');
    if (!descriptionElement || descriptionElement.dataset.accordionized === 'true') return;

    // Mark as processed
    descriptionElement.dataset.accordionized = 'true';

    // Hide the entire description element
    descriptionElement.style.display = 'none';
}

// Add resize handler to switch between tabs and accordions
let resizeTimeout;
window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
        const wasAccordion = accordionInitialized;
        const wasTabs = tabsInitialized;
        
        if (isMobile() && wasTabs) {
            // Switch from tabs to accordion
            tabsInitialized = false;
            accordionInitialized = false;
            // Re-trigger initialization
            const event = new CustomEvent('gpoElementChanged');
            document.dispatchEvent(event);
            // Create description accordion
            createDescriptionAccordion();
        } else if (!isMobile() && wasAccordion) {
            // Switch from accordion to tabs
            accordionInitialized = false;
            tabsInitialized = false;
            // Re-trigger initialization
            const event = new CustomEvent('gpoElementChanged');
            document.dispatchEvent(event);
        }
    }, 250);
});

// Modify your existing event listeners to include floating bar updates
document.addEventListener('gpoElementChanged', function() {
    if (!initialized) {
        initialize();
        markUnavailableSwatches();
        createFloatingBar();
        initializeSizeSlider(); // Initialize size slider on mobile
        createDescriptionAccordion(); // Create description accordion on mobile
        resetManualSizeSelections(); // Reset manual size selections on initialization
        initialized = true;

        // Initialize item count for notifications
        lastItemCount = getItemCount();
    }
    updateSummaryTable();
    updateFloatingBar();
    
    // Check for discount notifications on mobile
    if (isMobile()) {
        setTimeout(() => {
            checkForDiscountNotification();
        }, 200);
    }
});

// Add listener for radio button changes
document.addEventListener('change', function(e) {
    if (e.target.matches('input[type="radio"][data-type="image-swatches"]')) {
        updateSummaryTable();
        updateFloatingBar();
        
        // Update accordion height and selected text when selections change
        setTimeout(() => {
            updateAccordionHeight();
            updateAccordionSelectedText();
            updateConfirmButtonState(); // Update confirm button state
            checkForDiscountNotification(); // Check for discount notification
        }, 100);
    }
    
    // Also update for button-type selections (like size selections)
    if (e.target.matches('input[type="radio"][data-type="buttons"]')) {
        setTimeout(() => {
            updateAccordionHeight();
            updateAccordionSelectedText();
            updateConfirmButtonState(); // Update confirm button state
            checkForDiscountNotification(); // Check for discount notification
        }, 100);
    }
});


markUnavailableSwatches();

document.addEventListener('gpoElementChanged', function() {
    updateSummaryTable();
    
    // Update accordion height and selected text when GPO elements change
    if (isMobile() && accordionInitialized) {
        setTimeout(() => {
            updateAccordionHeight();
            updateAccordionSelectedText(); // Update selected text on any GPO change
        }, 150);
    }
});
/**
 * US Bed Size Toggle - Minimal Fix
 * Keeps the same appearance but fixes the functionality
 */
function initUSBedSizeToggle() {
  // Create toggle element
  const toggleElement = document.createElement('div');
  toggleElement.className = 'us-size-toggle';
  toggleElement.innerHTML = `
    <label class="us-size-toggle__label">Show US Sizes</label>
    <label class="us-size-toggle__switch">
      <input type="checkbox" class="us-size-toggle__input">
      <span class="us-size-toggle__bg"></span>
    </label>
  `;

  // SPECIAL: Track the currently selected US size option, if any
  let currentlySelectedUSOption = null;

  // Function to hide/show US bed sizes
  function toggleUSBedSizes(show) {
    // Find ALL swatches (both buttons and image types)
    const usSizeSwatches = document.querySelectorAll('.gpo-swatches');
    
    usSizeSwatches.forEach(swatch => {
      const input = swatch.querySelector('input[type="radio"]');
      if (!input) return;
      
      const value = input.getAttribute('value') || '';
      
      // Check if this is a US size option
      const isUSSize = 
        value === 'USA King' || 
        value === 'California King';
      
      if (isUSSize) {
        // Store original display value if not already stored
        if (!swatch.dataset.originalDisplay) {
          swatch.dataset.originalDisplay = getComputedStyle(swatch).display;
        }
        
        // Show or hide based on toggle state
        swatch.style.display = show ? swatch.dataset.originalDisplay : 'none';
        
        // SPECIAL: If this option is currently checked and we're hiding it, we need to
        // ensure the summary table gets updated properly
        if (input.checked && !show) {
          // Remember this was selected before hiding
          currentlySelectedUSOption = input;
          
          // Uncheck it (since it's being hidden)
          input.checked = false;
          
          // Manually trigger an update of the summary table
          updateSummaryTable();
          updateFloatingBar();
        }
      }
    });
  }

  // Add event listener to toggle
  const checkbox = toggleElement.querySelector('.us-size-toggle__input');
  checkbox.onclick = function() {
    const showUSSizes = this.checked;
    toggleUSBedSizes(showUSSizes);
    
    // SPECIAL: If we're showing US sizes again and we had a previously selected US option,
    // restore its selected state
    if (showUSSizes && currentlySelectedUSOption) {
      // Don't automatically re-select, just let the user know they can select it again
      // (automatically re-selecting could cause unexpected behavior)
      currentlySelectedUSOption = null;
    }
    
    // Update accordion height after toggling US sizes
    setTimeout(() => {
      updateAccordionHeight();
    }, 100);
  };

  // Insert toggle in appropriate location
  function insertToggle() {
    // Find an appropriate location - after tab controls if they exist
    const tabControls = document.getElementById('tab-controls');
    if (tabControls) {
      tabControls.parentNode.insertBefore(toggleElement, tabControls.nextSibling);
      return true;
    }

    // Or before the first group of swatches
    const firstSwatchGroup = document.querySelector('.gpo-element.gpo-form__group');
    if (firstSwatchGroup) {
      firstSwatchGroup.parentNode.insertBefore(toggleElement, firstSwatchGroup);
      return true;
    }

    return false;
  }

  // Try to insert the toggle, retry a few times if necessary
  let insertAttempts = 0;
  const maxAttempts = 5;

  function attemptInsert() {
    if (insertToggle() || insertAttempts >= maxAttempts) {
      // After inserting, hide US sizes with a delay to ensure DOM is ready
      setTimeout(() => {
        toggleUSBedSizes(false);
      }, 100);
      return;
    }

    insertAttempts++;
    setTimeout(attemptInsert, 500);
  }

  attemptInsert();
  
  // SPECIAL: Add custom listener for button-type US size selections
  // Function to reset manual size selections (useful when starting fresh)
  function resetManualSizeSelections() {
    window.manuallySelectedSizes = new Set();
  }

  // Function to synchronize sizes across all product categories
  function synchronizeSizes(selectedSize, sourceFieldName) {
    // Track which categories have been manually selected
    if (!window.manuallySelectedSizes) {
      window.manuallySelectedSizes = new Set();
    }

    // Mark the source as manually selected
    window.manuallySelectedSizes.add(sourceFieldName);

    // Map bed sizes to pillowcase sizes
    const pillowcaseSizeMap = {
      'Single': 'Standard',
      'King Single': 'Standard',
      'Double': 'Standard',
      'Queen': 'Standard',
      'King': 'King',
      'Super King': 'King',
      'USA King': 'King',
      'California King': 'King',
      'Cot': 'Standard' // Default to Standard for Cot
    };

    // Find all size radio buttons
    const allSizeButtons = document.querySelectorAll('input[type="radio"][data-type="buttons"][data-field-name*="Size"]');

    allSizeButtons.forEach(button => {
      const fieldName = button.getAttribute('data-field-name');

      // Skip if this is the source field or if it's been manually selected
      if (fieldName === sourceFieldName || window.manuallySelectedSizes.has(fieldName)) {
        return;
      }

      // Skip disabled buttons
      if (button.disabled) {
        return;
      }

      let targetSize = selectedSize;

      // Handle special mapping for pillowcase sizes
      if (fieldName.includes('Pillowcase Size')) {
        targetSize = pillowcaseSizeMap[selectedSize];
        if (!targetSize) {
          return; // Skip if no mapping exists
        }
      }

      // Check if this size option exists for this category
      if (button.value === targetSize) {
        // Check if any option in this category is already selected
        const categoryButtons = document.querySelectorAll(`input[type="radio"][data-field-name="${fieldName}"]`);
        let hasSelection = false;

        categoryButtons.forEach(catButton => {
          if (catButton.checked) {
            hasSelection = true;
          }
        });

        // Only select if no option is currently selected in this category
        if (!hasSelection) {
          button.checked = true;

          // Trigger change event to update all dependent UI elements
          const changeEvent = new Event('change', {
            bubbles: true,
            cancelable: true
          });
          button.dispatchEvent(changeEvent);

          // Also trigger click to ensure GPO elements update
          const clickEvent = new Event('click', {
            bubbles: true,
            cancelable: true
          });
          button.dispatchEvent(clickEvent);

          // Trigger GPO element changed event for the app to update
          const gpoEvent = new CustomEvent('gpoElementChanged', {
            bubbles: true,
            cancelable: true
          });
          document.dispatchEvent(gpoEvent);

          // Auto-scroll to show the selected size on mobile
          if (window.innerWidth <= 768) {
            const buttonWrapper = button.closest('.gpo-swatches.buttons');
            const sliderContainer = button.closest('.gpo-ov-wrapper.horizontal') ||
                                   button.closest('.size-slider-mobile') ||
                                   button.closest('[class*="-size"] .gpo-ov-wrapper');

            if (buttonWrapper && sliderContainer) {
              // Small delay to ensure DOM updates are complete
              setTimeout(() => {
                buttonWrapper.scrollIntoView({
                  behavior: 'smooth',
                  inline: 'center',
                  block: 'nearest'
                });
              }, 100);
            }
          }

          // Ensure the builder class remains on the media viewer if there are selected images
          const mediaViewer = document.querySelector('.media-viewer');
          if (mediaViewer) {
            // Check if there are any selected image swatches
            const hasImageSelections = document.querySelectorAll('input[type="radio"][data-type="image-swatches"]:checked').length > 0;
            if (hasImageSelections && !mediaViewer.classList.contains('builder')) {
              mediaViewer.classList.add('builder');
            }
          }
        }
      }
    });
  }

  document.addEventListener('change', function(e) {
    if (e.target.matches('input[type="radio"][data-type="buttons"]')) {
      const value = e.target.getAttribute('value') || '';
      const fieldName = e.target.getAttribute('data-field-name') || '';

      // Handle size synchronization
      if (fieldName.includes('Size') && e.target.checked) {
        // Don't sync for pillowcase sizes as they use different values
        if (!fieldName.includes('Pillowcase Size')) {
          synchronizeSizes(value, fieldName);
        } else {
          // Mark pillowcase as manually selected
          if (!window.manuallySelectedSizes) {
            window.manuallySelectedSizes = new Set();
          }
          window.manuallySelectedSizes.add(fieldName);
        }
      }

      // Handle US size toggle tracking
      if (value === 'USA King' || value === 'California King') {
        // Update the current selection
        currentlySelectedUSOption = e.target;

        // NOTE: We don't need to trigger updateSummaryTable here because the
        // change event will still bubble up to your existing change listener
        // that calls updateSummaryTable for image-swatches
      }
    }
  });
}

// Initialize when GPO elements are ready
document.addEventListener('gpoElementChanged', function() {
  // Only initialize once
  if (!window.usBedSizeToggleInitialized) {
    initUSBedSizeToggle();
    window.usBedSizeToggleInitialized = true;
  }
});

// Also try to initialize on DOMContentLoaded as a fallback
document.addEventListener('DOMContentLoaded', function() {
  if (!window.usBedSizeToggleInitialized) {
    setTimeout(() => {
      if (!window.usBedSizeToggleInitialized) {
        initUSBedSizeToggle();
        window.usBedSizeToggleInitialized = true;
      }
    }, 1000);
  }
  
  // Initialize size slider on DOMContentLoaded as well
  setTimeout(() => {
    initializeSizeSlider();
    createDescriptionAccordion(); // Create description accordion on mobile
  }, 1500);

  // Handle sticky image behavior on mobile
  if (isMobile()) {
    // Look for media-viewer with builder class directly (corrected selector)
    const mediaViewer = document.querySelector('.media-viewer.builder');
    if (mediaViewer) {
      let ticking = false;

      function handleScroll() {
        if (!ticking) {
          window.requestAnimationFrame(function() {
            // Add class when scrolled more than 50px
            if (window.pageYOffset > 50) {
              mediaViewer.classList.add('is-scrolled');
            } else {
              mediaViewer.classList.remove('is-scrolled');
            }
            ticking = false;
          });
          ticking = true;
        }
      }

      // Initial check
      if (window.pageYOffset > 50) {
        mediaViewer.classList.add('is-scrolled');
      }

      // Add scroll listener
      window.addEventListener('scroll', handleScroll, { passive: true });
    } else {
      // If not found initially, check again after a delay since builder class is added dynamically
      setTimeout(() => {
        const delayedMediaViewer = document.querySelector('.media-viewer.builder');
        if (delayedMediaViewer && !delayedMediaViewer.dataset.stickyInitialized) {
          // Use the helper function from bed-builder-main.js if available
          if (typeof initializeMobileStickyBehavior === 'function') {
            initializeMobileStickyBehavior(delayedMediaViewer);
            delayedMediaViewer.dataset.stickyInitialized = 'true';
          }
        }
      }, 1000);
    }
  }
});

// Mobile Discount Notification System
let lastNotificationTime = 0;
let lastItemCount = 0;
let notificationCooldown = 5000; // 5 seconds between notifications

function showDiscountNotification(itemCount, previousCount) {
    // Only show on mobile
    if (!isMobile()) {
        return;
    }
    
    // Check cooldown
    const now = Date.now();
    const timeSinceLastNotification = now - lastNotificationTime;
    
    if (timeSinceLastNotification < notificationCooldown) {
        return;
    }
    
    // Don't show for decreases or no change
    if (itemCount <= previousCount) {
        return;
    }
    
    // Create or get notification container
    let container = document.querySelector('.mobile-discount-notification');
    if (!container) {
        container = document.createElement('div');
        container.className = 'mobile-discount-notification';
        document.body.appendChild(container);
    }
    
    // Clear any existing notification
    container.innerHTML = '';
    container.classList.remove('show', 'achievement', 'near-discount');
    
    let message = '';
    let isAchievement = false;
    
    // Determine message based on item count
    if (itemCount === 1) {
        message = 'Great start! Add 2 more for 10% off';
    } else if (itemCount === 2) {
        message = 'Almost there! 1 more item for 10% off';
    } else if (itemCount === 3) {
        message = "Nice! You've unlocked 10% off";
        isAchievement = true;
    } else if (itemCount >= 4) {
        message = "Amazing! You've unlocked 15% off";
        isAchievement = true;
    }
    
    // Create notification content
    const notification = document.createElement('div');
    notification.className = 'notification-content';
    
    // Add message
    const messageEl = document.createElement('div');
    messageEl.className = 'notification-message';
    messageEl.textContent = message;
    notification.appendChild(messageEl);
    
    // Add progress bar for dismissal timer
    const progressBar = document.createElement('div');
    progressBar.className = 'notification-progress';
    notification.appendChild(progressBar);
    
    // Add to container
    container.appendChild(notification);
    
    // Apply appropriate class
    if (isAchievement) {
        container.classList.add('achievement');
    } else {
        container.classList.add('near-discount');
    }
    
    // Show notification with animation
    setTimeout(() => {
        container.classList.add('show');
    }, 10);
    
    // Auto-hide after 4 seconds
    setTimeout(() => {
        container.classList.remove('show');
    }, 4000);
    
    // Update last notification time
    lastNotificationTime = now;
}

// Track item count changes
function checkForDiscountNotification() {
    const currentItemCount = getItemCount();
    
    // Only trigger if count increased
    if (currentItemCount > lastItemCount) {
        showDiscountNotification(currentItemCount, lastItemCount);
    }
    
    lastItemCount = currentItemCount;
}

// Test function for console debugging
window.testNotification = function(itemCount = null) {
    if (itemCount === null) {
        itemCount = getItemCount();
    }
    showDiscountNotification(itemCount, 0);
    return 'Notification triggered for ' + itemCount + ' items';
};